import { SUPPORT_SCAN_STATUS } from '../constants/support';
/** `null` / absent means the server attached no verdict (an already-scanned file): clean. */
export function scanStateOf(status) {
    if (status === null || status === undefined || status === SUPPORT_SCAN_STATUS.CLEAN)
        return 'ready';
    if (status === SUPPORT_SCAN_STATUS.PENDING)
        return 'scanning';
    return 'unchecked';
}
const KNOWN_STATUSES = Object.values(SUPPORT_SCAN_STATUS);
/**
 * A wire `scan_status` as a `UserFileRef.scan_status`: no verdict is clean, a recognised verdict
 * passes through, and anything else becomes `scan_error` so it can never be opened by accident.
 */
export function normalizeScanStatus(raw) {
    if (raw === null || raw === undefined)
        return SUPPORT_SCAN_STATUS.CLEAN;
    return typeof raw === 'string' && KNOWN_STATUSES.includes(raw)
        ? raw
        : SUPPORT_SCAN_STATUS.ERROR;
}
/**
 * Thrown by the attachment URL resolver when the server refuses to serve a file because of its
 * scan (409 `SCAN_PENDING` / `SCAN_FAILED`). The chip catches it and shows the same state a scan
 * verdict on the message would have shown.
 */
export class AttachmentScanError extends Error {
    constructor(state) {
        super(`Attachment is not available: ${state}`);
        this.name = 'AttachmentScanError';
        this.state = state;
    }
}
